import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import useFormValidator from 'useFormValidator';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';
import PinModalContainer from './PinModalContainer';

const form = {
  first_name: '',
  middle_name: '',
  last_name: '',
  email: '',
  password: '',
  password_confirmation: '',
};

function AddSubscriberModal({
  updating,
  // showTransaction,
  // getTransactionList,
  createAccount,
}) {

  const [formData, setFormData] = useState(form);

  const setModal = useContext(ModalContext);
  const [formMobile, setFormMobile] = React.useState({
    mobile_number: ""
  });
  const mobileNumberValidator = useFormValidator(formMobile, {
    mobile_number: 'required|cellphone_number',
  })

  const validateForm = useFormValidator(formData, {
    first_name: 'required',
    last_name: 'required',
    email: 'required|email',
    password: 'required|password',
    password_confirmation: 'required|match:password|password',
  });

  const handleOnSubmit = e => {
    e.preventDefault();
    const args = {
      ...formData,
      first_name: _.get(formData, 'first_name').toUpperCase(),
      middle_name: _.get(formData, 'middle_name').toUpperCase(),
      last_name: _.get(formData, 'last_name').toUpperCase(),
      is_resident: 0,
      mobile_number: _.get(formMobile, 'mobile_number'),
    };
    createAccount(args, () => {
      setModal({
        isOpen: true,
        content: <PinModalContainer mobileNo={args.mobile_number} password={formData.password} />,
        title: 'Enter OTP for this mobile number',
        modalSize: 'modal-md',
      });

    });
  };

  const onChange = e => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mx-auto">
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              First Name: {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name') || ''}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">Middle Name:</label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name') || ''}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Last Name: {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name') || ''}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Mobile Number&nbsp;{mobileNumberValidator.renderMessage('mobile_number')}
            </label>
            <FormInputMobile
              disableDropdown={false}
              autoComplete="off"
              type="tel"
              name="mobile_number"
              onChange={setFormMobile}
              value={formMobile.mobile_number || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Email Address: {validateForm.renderMessage('email')}
            </label>
            <input
              className="form-control"
              type="email"
              name="email"
              onChange={onChange}
              value={_.get(formData, 'email') || ''}
              autoComplete="off"
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Password: {validateForm.renderMessage('password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password"
              onChange={onChange}
              value={_.get(formData, 'password') || ''}
              autoComplete="off"
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label mb-0">
              Confirm Password:{' '}
              {validateForm.renderMessage('password_confirmation')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password_confirmation"
              onChange={onChange}
              value={_.get(formData, 'password_confirmation') || ''}
              autoComplete="off"
            />
          </div>
          <div className="col-12">
            <div className="alert alert-info mt-3 p-0" role="alert">
              <ul className="mb-0">
                <li>Minimum of 8 Characters</li>
                <li>At least one uppercase and lowercase letter</li>
                <li>At least one symbol</li>
                <li>At least one number</li>
              </ul>
            </div>
          </div>
        </div>
        <hr />

        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              formData.password !== formData.password_confirmation || !mobileNumberValidator.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3 "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
AddSubscriberModal.propTypes = {
  updating: PropTypes.bool.isRequired,
  // showTransaction: PropTypes.instanceOf(Function).isRequired,
  createAccount: PropTypes.instanceOf(Function).isRequired,
  // getTransactionList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CREATE_ACCOUNT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(AddSubscriberModal);
